import { Subscription } from "rxjs"

import { ROUTES_CONFIG } from "@/constants"
import { constructUrl } from "@/utils/constructUrl"
import { openWindow } from "@/utils/openWindow"

import {
  Section,
  sectionConfig,
  tearOutSection,
  TearOutSectionEntry,
  tearOutSectionEntry$,
  tornOutSections$,
} from "./tearOutSection.state"
import { tearOutMessages$ } from "./tearOutSection.transport"
import { isTornOutDocument } from "./tornOutDocument"

const openWindows = new Map<Section, Window>()

const handleEntry = ([
  tornOut,
  section,
  width,
  height,
]: TearOutSectionEntry) => {
  if (!tornOut) {
    openWindows.delete(section)
    return
  }

  const existing = openWindows.get(section)
  if (existing && !existing.closed) {
    existing.focus()
    return
  }

  const config = sectionConfig[section]
  openWindow(
    {
      url: constructUrl(ROUTES_CONFIG[section]),
      name: section,
      width: width ?? config.width,
      height: height ?? config.height,
    },
    () => {
      openWindows.delete(section)
      tearOutSection(false, section)
    },
  ).then((win) => {
    if (win) openWindows.set(section, win)
  })
}

export const startTearOutWindows = () => {
  const sub = new Subscription()
  // Pins the accumulator for the app's lifetime; without it the state resets on unmount
  sub.add(tornOutSections$.subscribe())
  // A popout must never spawn popouts
  if (!isTornOutDocument) {
    sub.add(tearOutSectionEntry$.subscribe(handleEntry))
    // Remote commands (e.g., from devtools console) re-enter via the same signal local clicks use,
    // so the accumulator only ever has one input.
    sub.add(
      tearOutMessages$.subscribe(({ section }) =>
        tearOutSection(false, section),
      ),
    )
  }
  return sub
}
